// extracted by mini-css-extract-plugin
export default {"tabs_list":"tabs_tabs_list__VnF2L","tabs__link":"tabs_tabs__link__h-NQ4"};